/* eslint-disable */
// Hand-authored, IP-safe holiday loader scene (Tolkien's Birthday, Jan 3) in the handoff idiom.
const rnd = (a, b) => a + Math.random() * (b - a);

/* ---- Tolkien's Birthday (Jan 3): a cozy storybook shire at dusk. IP-SAFE —
        original silhouettes only: rolling green hills with a round-doored
        hill-cottage (warm window, chimney smoke) on the left, a winding pale
        path, and a grey wandering-wizard silhouette (wide-brimmed pointed hat,
        glowing staff tip) walking across the foreground meadow. A distant
        fire-lit peak smoulders far right, a plain gold ring glints on a
        foreground stone, and fireflies drift over the grass. Deep indigo dusk
        with a warm amber horizon; the composited centre badge zone
        (x 150-210, y 82-138) stays clear. ---- */
function lotrScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'lt' + Math.random().toString(36).slice(2, 7);

  // ---- rolled traits ----
  const AC    = pick(['#ffd98a', '#a9e8ff', '#b9f0a0']); // staff-tip glow accent
  const shoot = Math.random() < 0.6;                     // occasional shooting star
  const wisps = pick([2, 3]);                            // chimney smoke wisps

  // ---- dusk starfield, two layers (tiny + scattered so the calm centre stays calm) ----
  let farStars = '';
  for (let i = 0; i < 14; i++) {
    const x = rnd(6, 354), y = rnd(4, 96), r = rnd(0.4, 0.9), d = rnd(0, 3), o = rnd(0.18, 0.45);
    farStars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(2)}" fill="#cfd9f2" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }
  let stars = '';
  for (let i = 0; i < 16; i++) {
    const x = rnd(6, 354), y = rnd(4, 90), r = rnd(0.6, 1.6), d = rnd(0, 2.4), o = rnd(0.45, 0.95);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#eef4ff" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // ---- thin crescent moon, top-left, with a soft halo ----
  const moon = `<g transform="translate(52,28)">
    <circle class="glow" r="16" fill="url(#${uid}moonGlow)"/>
    <path d="M6,-9 A11 11 0 1 0 6,9 A8.6 8.6 0 1 1 6,-9 Z" fill="#f2ecd8" opacity="0.92"/>
  </g>`;

  // ---- optional shooting star, high right ----
  const streak = shoot
    ? `<g transform="translate(268,10)"><g class="shoot"><path d="M0,0 L-15,-6" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" opacity="0.5"/><circle r="1.5" fill="#ffffff"/></g></g>`
    : '';

  // ---- distant fire-lit peak cluster, far right (outside the badge zone) ----
  const peaks = `<g>
    <path d="M222,156 L258,102 L282,132 L306,86 L330,124 L360,104 V160 H222 Z" fill="url(#${uid}peakFar)"/>
    <g transform="translate(306,88)">
      <circle class="glow" r="11" fill="url(#${uid}ember)"/>
      <path d="M0,-2 L-6,10 L6,10 Z" fill="#4a2530" opacity="0.85"/>
      <path d="M0,-2 L-1.6,4 L1.4,7" fill="none" stroke="#ff7a45" stroke-width="0.9" opacity="0.8"/>
    </g>
    <path d="M242,156 L268,124 L292,148 L318,116 L344,144 L360,136 V160 H242 Z" fill="url(#${uid}peakNear)"/>
  </g>`;

  // ---- drifting valley mist over the mountain feet ----
  const mist =
      `<g transform="translate(288,142)"><g class="drift" style="animation-duration:14s"><ellipse rx="58" ry="9" fill="url(#${uid}mist)"/></g></g>`
    + `<g transform="translate(96,128)"><g class="drift" style="animation-duration:18s"><ellipse rx="46" ry="7" fill="url(#${uid}mist)" opacity="0.7"/></g></g>`;

  // ---- rolling green hills (back → mid → foreground meadow) ----
  const hills =
      `<path d="M0,150 Q90,136 190,146 Q280,154 360,146 V220 H0 Z" fill="url(#${uid}hill1)"/>`
    + `<path d="M0,168 Q110,152 220,164 T360,160 V220 H0 Z" fill="url(#${uid}hill2)"/>`;
  const meadow = `<path d="M0,190 Q120,178 240,188 T360,184 V220 H0 Z" fill="url(#${uid}hill3)"/>`;

  // ---- chimney smoke wisps (reuses .steam / .steam-wob with inline timing) ----
  let smoke = '';
  for (let i = 0; i < wisps; i++) {
    const dur = rnd(4.6, 6.4), wob = rnd(2.6, 3.6), dl = -rnd(0, 4), sx = -1 + i * 2;
    smoke +=
        `<g transform="translate(${(43 + sx).toFixed(1)},126)">`
      + `<g class="steam" style="animation-duration:${dur.toFixed(1)}s;animation-delay:${dl.toFixed(1)}s">`
      + `<g class="steam-wob" style="animation-duration:${wob.toFixed(1)}s;animation-delay:${dl.toFixed(1)}s">`
      + `<path d="M0,0 C-3,-6 3,-11 0,-17" fill="none" stroke="url(#${uid}smoke)" stroke-width="2.6" stroke-linecap="round"/>`
      + `</g></g></g>`;
  }

  // ---- the hill-cottage: a grassy mound with a round door, warm round window, stone chimney ----
  const cottage = `<g>
    <path d="M14,166 Q22,128 66,126 Q110,128 118,166 Z" fill="url(#${uid}mound)"/>
    <path d="M14,166 Q22,128 66,126 Q110,128 118,166" fill="none" stroke="#1c3324" stroke-width="1" opacity="0.5"/>
    <rect x="39" y="122" width="8" height="10" rx="1.4" fill="url(#${uid}chimney)"/>
    <rect x="37.8" y="120.6" width="10.4" height="3" rx="1.5" fill="#57534e"/>
    ${smoke}
    <circle cx="66" cy="152" r="13.4" fill="#2a1d12"/>
    <circle cx="66" cy="152" r="11.2" fill="url(#${uid}door)"/>
    <g stroke="#2a1d12" stroke-width="0.8" opacity="0.55">
      <line x1="62.3" y1="141.4" x2="62.3" y2="162.6"/><line x1="66" y1="140.8" x2="66" y2="163.2"/><line x1="69.7" y1="141.4" x2="69.7" y2="162.6"/>
    </g>
    <circle cx="66" cy="152" r="11.2" fill="none" stroke="#c9a86a" stroke-width="0.9" opacity="0.65"/>
    <circle cx="70.6" cy="152" r="1.15" fill="#e8c37a"/>
    <g transform="translate(94,146)">
      <circle class="glow" r="8" fill="url(#${uid}winGlow)"/>
      <circle r="4.4" fill="url(#${uid}window)"/>
      <circle r="4.4" fill="none" stroke="#3d2c18" stroke-width="1.1"/>
      <line x1="-4.4" y1="0" x2="4.4" y2="0" stroke="#3d2c18" stroke-width="0.8"/>
      <line x1="0" y1="-4.4" x2="0" y2="4.4" stroke="#3d2c18" stroke-width="0.8"/>
    </g>
  </g>`;

  // ---- winding pale path from the door down to the foreground ----
  const path = `<path d="M60,166 Q84,172 116,176 Q168,182 206,192 Q252,204 292,220 L252,220 Q200,202 156,194 Q104,186 68,172 Z" fill="url(#${uid}path)" opacity="0.8"/>`;

  // ---- a plain gold ring glinting on a foreground stone ----
  const ring = `<g transform="translate(286,199)">
    <ellipse cx="0" cy="4.6" rx="10" ry="3" fill="rgba(6,12,10,0.5)"/>
    <path d="M-9,4 Q-7,-2 0,-2 Q7,-2 9,4 Z" fill="url(#${uid}stone)"/>
    <circle class="glow" cy="-5" r="8" fill="url(#${uid}ringGlow)"/>
    <circle cy="-5" r="3.6" fill="none" stroke="url(#${uid}gold)" stroke-width="2"/>
    <g transform="translate(3,-7.4)"><path class="twinkle" d="M0,-2.6 L0.7,-0.7 L2.6,0 L0.7,0.7 L0,2.6 L-0.7,0.7 L-2.6,0 L-0.7,-0.7 Z" fill="#fff3c9"/></g>
  </g>`;

  // ---- fireflies drifting over the meadow ----
  let fireflies = '';
  for (let i = 0; i < 6; i++) {
    const x = rnd(16, 344), y = rnd(158, 204), r = rnd(0.9, 1.5), d = rnd(0, 2.6);
    fireflies += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#d9ef8f" opacity="0.85" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // ---- HERO: a grey wandering-wizard silhouette walking the meadow (glowing staff tip) ----
  const wizard = `<g class="lotr-walk"><g transform="translate(0,208)"><g class="lotr-stride">
    <ellipse cx="0" cy="1" rx="10" ry="2.4" fill="rgba(6,12,10,0.45)"/>
    <line x1="8.5" y1="0" x2="11.5" y2="-38" stroke="#6b5138" stroke-width="1.7" stroke-linecap="round"/>
    <circle class="glow" cx="11.7" cy="-40" r="5.5" fill="${AC}" opacity="0.3"/>
    <circle cx="11.7" cy="-40" r="1.7" fill="${AC}"/>
    <path d="M-7,0 Q-8,-16 -3,-26 L3,-26 Q8,-16 6,0 Z" fill="url(#${uid}robe)"/>
    <path d="M-3,-26 Q0,-30 3,-26 Q6,-14 4,-4 L1,-4 Q2,-16 0,-22 Q-2,-16 -2,-6 Z" fill="rgba(10,14,24,0.22)"/>
    <path d="M0,-27 L-1,-21 L1.6,-20.4 Z" fill="#b7bcc9"/>
    <circle cx="0" cy="-29.5" r="3" fill="#a9aebd"/>
    <ellipse cx="0" cy="-32.6" rx="7.6" ry="1.7" fill="url(#${uid}hat)"/>
    <path d="M-4.6,-32.8 Q-1,-45 2.4,-44 Q3.4,-40 3.8,-32.8 Z" fill="url(#${uid}hat)"/>
  </g></g></g>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="A round-doored hill cottage in rolling green hills at dusk, a wandering wizard on the meadow path, and a distant fire-lit peak.">
    <defs>
      <linearGradient id="${uid}sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#101638"/><stop offset="0.45" stop-color="#25305a"/><stop offset="0.75" stop-color="#4d4067"/><stop offset="1" stop-color="#a2634f"/>
      </linearGradient>
      <radialGradient id="${uid}moonGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(242,236,216,0.4)"/><stop offset="1" stop-color="rgba(242,236,216,0)"/>
      </radialGradient>
      <linearGradient id="${uid}peakFar" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#4d3f5e"/><stop offset="1" stop-color="#2c2645"/></linearGradient>
      <linearGradient id="${uid}peakNear" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#37304f"/><stop offset="1" stop-color="#211d38"/></linearGradient>
      <radialGradient id="${uid}ember" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,122,69,0.75)"/><stop offset="0.55" stop-color="rgba(214,74,52,0.3)"/><stop offset="1" stop-color="rgba(214,74,52,0)"/>
      </radialGradient>
      <radialGradient id="${uid}mist" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(214,224,240,0.3)"/><stop offset="1" stop-color="rgba(214,224,240,0)"/>
      </radialGradient>
      <linearGradient id="${uid}hill1" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3f6b45"/><stop offset="1" stop-color="#2b4c35"/></linearGradient>
      <linearGradient id="${uid}hill2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2e5238"/><stop offset="1" stop-color="#1e3a29"/></linearGradient>
      <linearGradient id="${uid}hill3" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1a3323"/><stop offset="1" stop-color="#0e2016"/></linearGradient>
      <radialGradient id="${uid}mound" cx="0.42" cy="0.24" r="0.9">
        <stop offset="0" stop-color="#4c7a4e"/><stop offset="0.6" stop-color="#35583c"/><stop offset="1" stop-color="#24402d"/>
      </radialGradient>
      <linearGradient id="${uid}chimney" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#6e6a63"/><stop offset="1" stop-color="#44413c"/></linearGradient>
      <linearGradient id="${uid}smoke" x1="0" y1="1" x2="0" y2="0">
        <stop offset="0" stop-color="rgba(206,214,226,0.55)"/><stop offset="1" stop-color="rgba(206,214,226,0)"/>
      </linearGradient>
      <radialGradient id="${uid}door" cx="0.38" cy="0.34" r="0.85">
        <stop offset="0" stop-color="#8a5a2e"/><stop offset="0.6" stop-color="#6a421f"/><stop offset="1" stop-color="#4a2d14"/>
      </radialGradient>
      <radialGradient id="${uid}window" cx="0.5" cy="0.42" r="0.6">
        <stop offset="0" stop-color="#ffe9a8"/><stop offset="1" stop-color="#e8a84e"/>
      </radialGradient>
      <radialGradient id="${uid}winGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,214,138,0.55)"/><stop offset="1" stop-color="rgba(255,214,138,0)"/>
      </radialGradient>
      <linearGradient id="${uid}path" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#c9b98c"/><stop offset="1" stop-color="#8d7c56"/></linearGradient>
      <linearGradient id="${uid}stone" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#5d6572"/><stop offset="1" stop-color="#353b46"/></linearGradient>
      <radialGradient id="${uid}ringGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,206,96,0.5)"/><stop offset="1" stop-color="rgba(255,206,96,0)"/>
      </radialGradient>
      <linearGradient id="${uid}gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#ffe9a6"/><stop offset="0.5" stop-color="#e8b34c"/><stop offset="1" stop-color="#b57e22"/>
      </linearGradient>
      <linearGradient id="${uid}robe" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8d93a6"/><stop offset="1" stop-color="#545b70"/></linearGradient>
      <linearGradient id="${uid}hat" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#7d8396"/><stop offset="1" stop-color="#4c5266"/></linearGradient>
      <radialGradient id="${uid}cglow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,230,190,0.34)"/><stop offset="0.55" stop-color="rgba(160,190,150,0.14)"/><stop offset="1" stop-color="rgba(160,190,150,0)"/>
      </radialGradient>
    </defs>
    <rect width="360" height="220" fill="url(#${uid}sky)"/>
    ${farStars}
    ${stars}
    ${moon}
    ${streak}
    ${peaks}
    ${mist}
    ${hills}
    ${cottage}
    ${meadow}
    ${path}
    <ellipse cx="180" cy="112" rx="72" ry="54" fill="url(#${uid}cglow)"/>
    ${fireflies}
    ${ring}
    ${wizard}
  </svg>`;
}

export { lotrScene };
